import { render, staticRenderFns } from "./ManageZIPCodes.vue?vue&type=template&id=6af6d8d5&scoped=true&"
import script from "./ManageZIPCodes.vue?vue&type=script&lang=js&"
export * from "./ManageZIPCodes.vue?vue&type=script&lang=js&"
import style0 from "./ManageZIPCodes.vue?vue&type=style&index=0&id=6af6d8d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6d8d5",
  null
  
)

export default component.exports